/* Number ops */

// import Settings from "./settings";
import { handleError } from "./errors.service";
// import User from "./user";
import Storage from "./storage.service";
import { getNumberWithoutCountryCode, formatPhoneNumber } from "./helpers";
// import Products from "./products.service";
// import PlansService from "./plans.service";
// import CONSTANTS from "./constants.service";
import HTTP from "./http.service";
// import Errors from "./errors.service";

import { getFlowStatus } from "./user.service";

const commitNumber = (data) => {
	let config = {
		method: "post",
		url: "/numbers/commit_number",
		data: data,
	};
	return HTTP(config);
};

const getNumber = () => {
	let config = {
		method: "get",
		url: "/numbers",
	};

	let returned = HTTP(config);

	returned
		.then((numberResponse) => {
			if (numberResponse.data && numberResponse.data.numbers.length > 0) {
				setNumber(numberResponse.data.numbers[0]);
			}
		})
		.catch((error) => {});

	return returned;
};

const cancelNumber = (MSISDN) => {
	let data = {};
	data["number"] = "0" + MSISDN.substr(3);

	let config = {
		method: "delete",
		url: "/numbers",
		data: data,
	};

	let f = HTTP(config);

	f.then((res) => {}).catch((err) => {});

	return f;
};

const setNumber = (obj, typePassed) => {
	let msisdn_formatted = getNumberWithoutCountryCode(obj.MSISDN);
	msisdn_formatted = formatPhoneNumber(msisdn_formatted);

	let in_transfer_number = obj.InTransferTo;

	if (in_transfer_number) {
		Storage.set("in_transfer_number", in_transfer_number);
		let in_transfer_to_formatted = getNumberWithoutCountryCode(
			in_transfer_number
		);
		in_transfer_to_formatted = formatPhoneNumber(in_transfer_to_formatted);
		Storage.set("in_transfer_to_formatted", in_transfer_to_formatted);
	} else {
		Storage.clear("in_transfer_number");
	}

	Storage.set("number", obj);
	Storage.set("msisdn", obj.MSISDN);
	Storage.set("msisdn_formatted", msisdn_formatted);

	// Events.when_number_is_selected(obj);
};

const getNumberThenDeleteIt = () => {
	getNumber()
		.then((response) => {
			if (response.data && response.data.numbers.length > 0) {
				let number = response.data.numbers[0];
				cancelNumber(number["MSISDN"])
					.then((res) => {
						getFlowStatus()
							.then((res) => {})
							.catch((error) => {
								handleError(error, "getNumberThenDeleteIt getFlowStatus");
							});
					})
					.catch((error) => {
						handleError(error, "getNumberThenDeleteIt cancelNumber");
					});
			}
		})
		.catch((error) => {
			handleError(error, "getNumberThenDeleteIt getNumber");
		});
};

export {
	setNumber,
	getNumber,
	commitNumber,
	cancelNumber,
	getNumberThenDeleteIt,
};
